<ng-container *transloco="let t; read: 'providers.feedPage.gtfs'">
  <div class="flex h-full min-h-0 flex-col">
    <app-feed-page-header />

    <div class="min-h-0 flex-1 overflow-auto px-8 pb-10 pt-6">
      <div class="mx-auto grid max-w-[1180px] items-start gap-6" style="grid-template-columns: minmax(0, 1fr) 380px">
        <!-- Main card: tabs + active pane -->
        <div class="min-w-0 rounded-card bg-card shadow-hairline">
          <app-feed-tab-strip [tabs]="tabs()" [active]="activeTab()" (selected)="selectTab($event)" />
          <div class="flex flex-col gap-5 p-6" role="tabpanel">
            @switch (activeTab()) {
              @case ('general') {
                <app-feed-basics-card [bare]="true" />
              }
              @case ('static') {
                @if (isCreate) {
                  <div class="flex max-w-[640px] flex-col gap-1.5 rounded-control bg-sunken p-5">
                    <span class="text-[14px] font-semibold text-ink-1">{{ t('staticPane.createTitle') }}</span>
                    <p class="m-0 text-[13px] leading-5 text-ink-2">{{ t('staticPane.createBody') }}</p>
                  </div>
                } @else if (feed(); as f) {
                  <app-gtfs-static-schedule
                    [feedId]="f.id"
                    [liveFileSetId]="diagnostics()?.static?.fileSetId ?? null"
                    [liveVersion]="diagnostics()?.static?.versionNumber ?? null"
                    (changed)="onStaticChanged()"
                  />
                }
              }
              @case ('realtime') {
                <app-gtfs-config pane="realtime" [(value)]="gtfsConfig" />
              }
              @case ('departures') {
                <app-gtfs-config pane="departures" [(value)]="gtfsConfig" />
              }
              @case ('advanced') {
                <app-gtfs-config pane="advanced" [(value)]="gtfsConfig" />
              }
            }
          </div>
        </div>

        <!-- Right column: sticky, so health stays visible while long tabs scroll -->
        <div class="sticky top-0 flex flex-col gap-6">
          <app-gtfs-feed-health [snapshot]="snapshot()" [isLoading]="isDiagnosticsLoading()" [isCreate]="isCreate" />
          <app-feed-identity-card />
        </div>
      </div>
    </div>
  </div>
</ng-container>
